

const PageWrapper = (props) => {
    return (
      <>{props.children}</>
    );
  };
  
export default PageWrapper;